import BaseComponent from "../../baseComponent.js";
import styles from "../../common/tab.scss";

export default class Tab extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: props.tab ? props.tab.title : ""
    };
    this.timeout = null;
  }

  componentDidMount() {
    this.isEditMode = false;
    this.$inputTitle = $(this.refs.titleInput);
    $(this.refs.tab).hover(() => {
      if (!this.isEditMode) $(this.refs.actions).stop().fadeIn(200);
    }, () => {
      $(this.refs.actions).stop().fadeOut(200);
    });

    if (this.props.tab.isNew) {
      this.enableEdit();
    }
  }

  handleChange(event) {
    this.setState({title: event.target.value});
  }

  reset() {
    if (this.props.tab.isNew) {
      this.props.onAdd(this.state.title, this.props.tab.tabPosition);
    } else if (this.props.tab.title !== this.state.title) {
      this.props.onTitleChange(this.props.tab.persistenceId, this.state.title);
    }
    this.disableEdit();
  }

  enableEdit() {
    this.isEditMode = true;
    $(this.refs.actions).hide();
    $(this.refs.title).animate({opacity: 0}, 100, "easeInQuad", () => {
      $(this).css("display", "none");
      this.$inputTitle.show();
      this.$inputTitle.animate({opacity: 1}, 100, "easeInQuad", () => {
        this.$inputTitle.focus().select();
      });
    });
  }

  disableEdit() {
    this.isEditMode = false;
    this.$inputTitle.animate({opacity: 0}, 100, "easeInQuad", () => {
      this.$inputTitle.hide();
      $(this.refs.title).show();
      $(this.refs.title).animate({opacity: 1}, 100, "easeInQuad");
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      title: nextProps.tab.title
    })
  }

  handleDragStart(e) {
    $(this.refs.actions).hide();
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("data", JSON.stringify({
      dashboardId: this.props.tab.persistenceId,
      position: this.props.tab.tabPosition,
      type: "users"
    }));
  }

  handleDragEnd() {

  }

  handleDrop(e) {
    e.preventDefault();
    let data = JSON.parse(e.dataTransfer.getData('data'));
    if (data.type && data.type === "users") {
      if (this.props.tab.tabPosition !== data.position) {
        this.props.onDrop(data.dashboardId, this.props.tab.tabPosition, data.position);
      }
    }
  }

  handleClick() {
    this.props.onTabClick(this.props.tab.persistenceId);
  }

  preventDefault(e) {
    e.preventDefault();
  }

  handleDragEnter(e) {
  }

  handleDragLeave() {
  }

  remove() {
    this.props.onRemove(this.props.tab.persistenceId, this.props.tab.tabPosition);
  }

  render() {
    let titleStyle = this.props.tab.activated ? styles.activatedTitle : styles.title, style = {};
    let tabItem = <div style={{display: "flex", padding: "8px 0"}}>
      <div className={titleStyle} ref="title" draggable="true" data-type="users"
           onClick={() => this.handleClick()}
           onDragOver={e => this.preventDefault(e)} onDrop={e => this.handleDrop(e)}
           onDragEnter={e => this.handleDragEnter(e)} onDragLeave={e => this.handleDragLeave(e)}
           onDragStart={e => this.handleDragStart(e)} onDragEnd={e => this.handleDragEnd(e)}>{this.state.title}</div>
      <input type="text" className={styles.input} ref="titleInput"
             value={this.state.title} onChange={(e) => this.handleChange(e)} onBlur={() => this.reset()}/>
      <div className={styles.actions}>
        <div ref="actions">
          <i className="icon-note" onClick={() => this.enableEdit()}/>
          <i className="icon-close" onClick={() => this.remove()}/>
        </div>
      </div>
    </div>;

    if (isMobile()) {
      style["padding"] = "5px !important";
      tabItem = <div className={titleStyle} style={{width: "initial", maxWidth: "initial"}}
                     ref="title"
                     onClick={this.handleClick}>{this.state.title}</div>;
    }

    return (
      <div className="col s6 m4" ref="tab" style={style}>
        {tabItem}
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/tab/tab.jsx